<txtb-drawer
  [actionId]="action.id"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  #drawer
  [groupInfo]="groupInfo"
>
  <div
    main
    class="iframe-wrapper"
    draggable="false"
    (dragstart)="$event.preventDefault()"
    [class.is-hidden]="drawer.contentCollapse | async"
    [class.is-locked]="
      (drawer?.tool$ | async) ||
      (drawer?.textToolActive$ubject | async) ||
      (drawer?.textboxesActive$ | async)
    "
  >
    <iframe [src]="link$ | async" (load)="iframeLoaded($event.returnValue)"></iframe>
    <txtb-spinner class="loader" *ngIf="(iframeLoaded$ | async) === false"></txtb-spinner>
  </div>
</txtb-drawer>
